import { useState, useCallback } from "react";

/**
 * Simple hook to manage Chakra Drawer state.
 * Just manages open/close state - parent controls what content to render.
 */
export function useSidePanel() {
  const [open, setOpen] = useState(false);

  const openSidePanel = useCallback(() => {
    setOpen(true);
  }, []);

  const closeSidePanel = useCallback(() => {
    setOpen(false);
  }, []);

  const handleOpenChange = useCallback((details: { open: boolean }) => {
    setOpen(details.open);
  }, []);

  return { open, openSidePanel, closeSidePanel, handleOpenChange };
}
